import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackToDashboard() {
  return (
    <Link
      to="/dashboard"
      className="mb-6 inline-flex items-center gap-2 rounded-full border border-ink/10 bg-white px-4 py-2 text-sm font-semibold text-ink shadow-sm transition-colors hover:border-ink/20 hover:bg-ink/[0.02]"
    >
      <ArrowLeft className="h-4 w-4" />
      Back to dashboard
    </Link>
  );
}